<mat-icon [matTooltip]="Enums.CompanyType[companyType] | camelCaseToWords">{{iconMappings.CompanyType[companyType]}}</mat-icon>
